/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImpersonateResponse
 */
export interface ImpersonateResponse {
    /**
     * 
     * @type {string}
     * @memberof ImpersonateResponse
     */
    access_token: string;
}

/**
 * Check if a given object implements the ImpersonateResponse interface.
 */
export function instanceOfImpersonateResponse(value: object): value is ImpersonateResponse {
    if (!('access_token' in value) || value['access_token'] === undefined) return false;
    return true;
}

export function ImpersonateResponseFromJSON(json: any): ImpersonateResponse {
    return ImpersonateResponseFromJSONTyped(json, false);
}

export function ImpersonateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImpersonateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'access_token': json['access_token'],
    };
}

export function ImpersonateResponseToJSON(json: any): ImpersonateResponse {
    return ImpersonateResponseToJSONTyped(json, false);
}

export function ImpersonateResponseToJSONTyped(value?: ImpersonateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'access_token': value['access_token'],
    };
}

